import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { showNotification } from 'src/app/helpers/show-toast';
import { TestInCenter } from 'src/app/_models/center-test.model';
import { CentersService } from 'src/app/_services/centers.service';

@Component({
  selector: 'app-cetner-test',
  templateUrl: './cetner-test.component.html',
  styleUrls: ['./cetner-test.component.scss'],
})
export class CetnerTestComponent implements OnInit {
  pageTitle: string = 'Tests in Lab';
  placeholder: string = 'Search by test name …';
  tests: TestInCenter = { tests: [{}] };
  filteredTests: TestInCenter = { tests: [{}] };
  checkAll = false;
  centerId: number = 0;
  searchString: string = '';
  constructor(
    private centerTestService: CentersService,
    private activatedRoute: ActivatedRoute,
    public toastr: ToastrService,
    private router: Router,
    private spinner: NgxSpinnerService
  ) { }

  ngOnInit(): void {
    this.spinner.show();

    this.centerId = this.activatedRoute.snapshot.params.centerId;
    if (this.centerId) {
      this.tests.centerId = this.centerId;
      this.getAllTestsInCenter(this.centerId);
    }
  }

  getAllTestsInCenter(id) {
    this.centerTestService.getAllTestsInCenter(id).subscribe((res) => {
      this.tests.tests = res?.data?.tests;
      const allChecked = this.tests.tests.find(
        (test) => test.isChecked == false
      );
      this.checkAll = allChecked ? false : true;
      this.spinner.hide();

      this.filteredTests.tests = [...this.tests.tests];
    });
  }

  onSearchTest(searchString) {
    if (searchString) {
      this.searchString = searchString;
      this.centerTestService
      .searchCenterTestByName(searchString, this.centerId)
      .subscribe((response) => {
        this.filteredTests.tests = response['data']['tests'];
      });
    } else {
      this.searchString = '';
      this.filteredTests.tests = [...this.tests.tests];
    }
   
  }

  onSearchInputKeyup(searchString) {
    if (!searchString) {
      this.filteredTests.tests = [...this.tests.tests];
    }
  }

  onCheckAll() {
    this.tests.tests.map((test) => (test.isChecked = this.checkAll));
  }

  synchronizeChanges() {
    this.filteredTests.tests.forEach(filteredTest => {
      const mainTest = this.tests.tests.find(test => test.id === filteredTest.id);
      if (mainTest) {
        mainTest.isChecked = filteredTest.isChecked;
        mainTest.price = filteredTest.price;
        mainTest.lcaPrice = filteredTest.lcaPrice;
      }
    });
  }

  SaveTests() {
    let negativePrice = false;

    this.synchronizeChanges(); // Synchronize changes between lists

    const testsArray = { centerId: this.tests.centerId, tests: [] };

    this.tests.tests.forEach(test => {
      if (test.isChecked && test.price < 0) {
        showNotification(
          'danger',
          `Price cannot be a negative number`,
          this.toastr
        );
        negativePrice = true;
      } else {
        test.isChecked &&
          testsArray.tests.push({
            id: test.id,
            isChecked: test.isChecked,
            price: test.price < 0 ? 0 : test.price,
            lcaPrice: test.lcaPrice < 0 ? 0 : test.lcaPrice,
          });
      }
    });

    if (!negativePrice) {
      this.centerTestService.saveTestsForCenter(testsArray).subscribe((res) => {
        showNotification('success', `saved`, this.toastr);
      });
    }
  }

}
